import Pt from 'prop-types'
import { connect } from 'react-redux'

import UserDetails from '../../components/User/UserDetails'
import {
  makeSelectUser,
} from '../../redux/modules/user/selectors'

export const makeMapStateToProps = () => {
  const selectUser = makeSelectUser()

  return (state, ownProps) => ({
    user: selectUser(state, {
      userId: ownProps.userId,
    }),
  })
}

const WrappedUserDetails = connect(makeMapStateToProps)(UserDetails)

WrappedUserDetails.propTypes = {
  userId: Pt.number.isRequired,
}

export default WrappedUserDetails



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/User/UserDetails.js